
import {Validatable} from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			isFocused: false,
			val: ""
		};
	},
	props: {
		label: [String, Object],
		placeholder: [String, Object],
		value: String,
		number: Boolean,
		disabled: Boolean,
		fancy: Boolean,
		tabindex: [Number, String],
		autofocus: Boolean,
		password: Boolean,
		time: Boolean,
		upper: Boolean,
		forceNumber: Boolean,
		ucfirst: Boolean,
		icon: String,
		iconLeft: String,
		name: String,
		autocomplete: String,
		autocapitalize: String,
		forcefill: Boolean,
		hasError: Boolean,
		iconClickHandler: Function,
		iconTooltip: [String, Object],
		iconLeftTooltip: [String, Object],
		iconLeftClickHandler: Function,
		maxLength: Number,
		step: Number,
		// Emits the input event instead of the value on input
		emitEvent: Boolean
	},
	computed: {
		_iconClickHandler():Function | undefined{
			return this.$listeners["icon-click"] as Function || this.iconClickHandler || undefined;
		},
		_iconLeftClickHandler():Function | undefined {
			return this.$listeners["icon-left-click"] as Function || this.iconLeftClickHandler || undefined;
		},
		iconClickable():boolean {
			return this._iconClickHandler != undefined;
		},
		iconLeftClickable():boolean {
			return this._iconLeftClickHandler != undefined;
		},
		type(): string {
			if (this.password) {
				return "password";
			}
			if (this.time) {
				return "time";
			}
			if (this.forceNumber) {
				return "number";
			}
			return "text";
		},
		inputElement(): HTMLInputElement {
			return this.$refs.inputElement as HTMLInputElement;
		},
		hasIconRight(): boolean{
			return this.icon != "";
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(newValue: string) {
				if(newValue && this.ucfirst){
					this.val = newValue.replace(/^./, newValue[0].toUpperCase());
					return;
				}
				this.val = newValue;
			}
		}
	},
	methods: {
		input(event: Event) {
			if (this.emitEvent) {
				this.$emit("input", event);
			}else{
				this.$emit("input", (event.target as HTMLInputElement).value);
			}
		},
		onKeydown(event: KeyboardEvent) {
			this.$emit("keydown", event);
		},
		onKeyup(event: KeyboardEvent) {
			this.$emit("keyup", event);
		},
		onMouseDown(event:MouseEvent){
			this.$emit("mousedown", event);
		},
		onMouseUp(event:MouseEvent){
			this.$emit("mouseup", event);
		},
		onBlur(event: Event) {
			this.isFocused = false;
			this.$emit("blur", event);
		},
		onFocus(event: FocusEvent) {
			this.isFocused = true;
			this.$emit("focus", event);
		},
		focus() {
			this.inputElement.focus();
		},
		blur() {
			this.inputElement.blur();
		},
		onKeyPress(event: KeyboardEvent) {
			this.$emit("keypress", event);
		},
		onClick(e: Event) {
			if (this.disabled) {
				e.stopPropagation();
				e.preventDefault();
			}
		},
		onAnimationStart(event: AnimationEvent) {
			if (event.animationName == "onAutoFillStart") {
				// Fixes an issue with Chromes password autofill
				this.val = this.inputElement.value;
				this.$emit("input", this.val);
				if (this.isFocused) {
					this.blur();
					requestAnimationFrame(() => this.focus());
				} else {
					let activeElement = document.activeElement as HTMLElement || null;
					this.focus();
					requestAnimationFrame(() => {
						if (activeElement) {
							activeElement.focus();
						}
					});
				}
			}
		},
		iconLeftClick(){
			this.focus();
			if (this._iconLeftClickHandler){
				this._iconLeftClickHandler();
			}
		},
		iconClick(){
			this.focus();
			if (this._iconClickHandler){
				this._iconClickHandler();
			}
		},
		onPaste(event:ClipboardEvent){
			this.$emit("paste", event);
		}
	},
	mounted() {
		if (this.autofocus) {
			this.focus();
		}
		this.inputElement.addEventListener("animationstart", this.onAnimationStart);
	},
})
;
